import { ReactElement } from "react";
import { Breadcrumb } from "antd";

type Props = {
  position: Object[]
}

export default  function BreadCrumb(props: Props): ReactElement{
    let Items = props.position.map((el:any,index: number)=> <Breadcrumb.Item key={index}>{el}</Breadcrumb.Item> )
    return (<Breadcrumb style={{ margin: '16px 0' }}>
       {Items}
  </Breadcrumb>)
}